module.exports = __webpack_public_path__ + "img/Monga.98f84d74.svg";